import { Megaphone, Handshake, LayoutDashboard, GraduationCap, ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag } from "./motion";
import { scrollToSection } from "../lib/config";

const SOLUTIONS = [
  {
    icon: Megaphone,
    name: "Pulse Marketing",
    desc: "Campanhas de captação e estratégias de aquisição que colocam sua clínica em crescimento contínuo.",
    items: ["Meta Ads & Google Ads", "Landing pages de alta conversão", "Posicionamento e criativos premium"],
    span: "lg:col-span-7",
  },
  {
    icon: Handshake,
    name: "Pulse Comercial",
    desc: "Estruturação comercial completa: processos, scripts e treinamento de CRC para converter mais.",
    items: ["Treinamento de CRC e recepção", "Processos e scripts comerciais", "Acompanhamento de performance"],
    span: "lg:col-span-5",
  },
  {
    icon: LayoutDashboard,
    name: "Pulse Hub",
    desc: "CRM, funil, automações, chatbot e indicadores — a tecnologia que sustenta a operação.",
    items: ["CRM e funil de vendas", "Automações e chatbot WhatsApp", "Indicadores em tempo real"],
    span: "lg:col-span-5",
    href: "#hub",
  },
  {
    icon: GraduationCap,
    name: "Pulse Academy",
    desc: "Formação contínua de equipes comerciais e treinamento completo de uso da plataforma.",
    items: ["Formação de equipes comerciais", "Trilhas de capacitação", "Tutoriais da plataforma"],
    span: "lg:col-span-7",
    href: "#academy",
  },
];

export default function Solutions() {
  return (
    <section id="solucoes" data-testid="solutions-section" className="bg-ink py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-wrap items-end justify-between gap-8">
          <div className="max-w-2xl">
            <Reveal>
              <SectionTag>Ecossistema</SectionTag>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-bone leading-[1.12]" data-testid="solutions-title">
                Quatro soluções. <span className="text-gold">Um sistema de crescimento.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-bone/60 text-sm leading-relaxed">
              Marketing e estruturação comercial como produto principal — Hub e Academy como
              a tecnologia e a educação que sustentam o resultado.
            </p>
          </Reveal>
        </div>

        <div className="mt-16 grid lg:grid-cols-12 gap-6">
          {SOLUTIONS.map((s, i) => (
            <Reveal key={s.name} delay={0.08 * i} className={`${s.span} col-span-1`}>
              <div
                data-testid={`solution-card-${i}`}
                className="group relative h-full bg-graphite/50 border border-gold/15 rounded-3xl p-8 lg:p-10 overflow-hidden hover:border-gold/50 transition-[border-color] duration-500"
              >
                <div className="absolute -top-20 -right-20 w-56 h-56 rounded-full bg-gold/0 group-hover:bg-gold/10 blur-[70px] transition-[background-color] duration-700 pointer-events-none" />
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 rounded-2xl bg-ink border border-gold/25 flex items-center justify-center group-hover:bg-gold transition-colors duration-500">
                    <s.icon size={26} className="text-gold group-hover:text-ink transition-colors duration-500" />
                  </div>
                  <span className="font-display font-extrabold text-5xl text-bone/10 group-hover:text-gold/25 transition-colors duration-500">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-7 font-display font-extrabold text-2xl lg:text-3xl text-bone tracking-tight">{s.name}</h3>
                <p className="mt-3 text-bone/60 leading-relaxed max-w-md">{s.desc}</p>
                <ul className="mt-6 space-y-2.5">
                  {s.items.map((item) => (
                    <li key={item} className="flex items-center gap-3 text-sm text-bone/75">
                      <span className="w-1 h-1 rounded-full bg-gold" />
                      {item}
                    </li>
                  ))}
                </ul>
                <button
                  data-testid={`solution-cta-${i}`}
                  onClick={() => scrollToSection(s.href || "#diagnostico")}
                  className="mt-8 inline-flex items-center gap-2 text-gold font-display font-bold text-sm uppercase tracking-[0.16em] group/btn"
                >
                  Saiba mais
                  <ArrowUpRight size={16} className="transition-transform duration-300 group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1" />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
